import { Routes } from '@angular/router';
import { authGuard } from './infrastructure/guards/auth.guard';
import { loginGuard } from './infrastructure/guards/login.guard';
import { permissionGuard } from './infrastructure/guards/permission.guard';

export const routes: Routes = [
    {
        path: '',
        canActivate: [loginGuard],
        loadComponent: () => import('./features/authentication/ui/pages/authentication/authentication').then((c) => c.Authentication),
        loadChildren: () => import('./features/authentication/authentication-routes').then((r) => r.authenticationRoutes),
    },
    {
        path: 'offers',
        canActivate: [authGuard, permissionGuard],
        loadComponent: () => import('./features/offers/ui/pages/offers/offers').then((c) => c.Offers),
        loadChildren: () => import('./features/offers/offers-routes').then((r) => r.offersRoutes),
    },
    {
        path: 'segments',
        canActivate: [authGuard, permissionGuard],
        loadComponent: () => import('./features/segments/ui/pages/segments/segments').then((c) => c.Segments),
        loadChildren: () => import('./features/segments/segments-routes').then((r) => r.segmentsRoutes),
    },
    {
        path: 'campaigns',
        canActivate: [authGuard, permissionGuard],
        loadComponent: () => import('./features/campaigns/ui/pages/campaigns/campaigns').then((c) => c.Campaigns),
        loadChildren: () => import('./features/campaigns/campaigns-routes').then((r) => r.campaignsRoutes),
    },
    {
        path: 'impersonation',
        canActivate: [authGuard, permissionGuard],
        loadComponent: () => import('./features/impersonation/ui/pages/impersonation/impersonation').then((c) => c.Impersonation),
        loadChildren: () => import('./features/impersonation/impersonation-routes').then((r) => r.impersonationRoutes),
    },
];
